import React, { useContext } from 'react';
import { SecondaryButton, Icon, UtilsBlock } from '@hz-design-system/web-ui';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { GA_TRACK_EVENTS_ACTIONS } from '../../../utils/constants';
import EnvironmentContext from '../../../contexts/EnvironmentContext';

import Classes from './InspectionService.scss';

const InspectionService = () => {
  const { t } = useI18nContext();
  const { inspectionServiceImageUrl } = useContext(EnvironmentContext);

  return (
    <div className={`${Classes.root} hz-Page-section hz-Page-section--separated`}>
      <div className={Classes.content}>
        <Trans i18nKey="inspectionService.title" tagName="p" className={Classes.title} />
        <UtilsBlock marginBottom="xxs">
          <Icon name="car_body" className={Classes.icon} />
          <Trans i18nKey="inspectionService.usp1" tagName="span" />
        </UtilsBlock>
        <UtilsBlock marginBottom="xxs">
          <Icon name="car_history" className={Classes.icon} />
          <Trans i18nKey="inspectionService.usp2" tagName="span" />
        </UtilsBlock>
        <UtilsBlock marginBottom="xxs">
          <Icon name="clock" className={Classes.icon} />
          <Trans i18nKey="inspectionService.usp3" tagName="span" />
        </UtilsBlock>
        <Trans i18nKey="inspectionService.promo" tagName="p" className={Classes.promo} />
        <SecondaryButton
          as="a"
          data-testid="OKNBannerButton"
          rel="nofollow noopener"
          href="https://www.occasionkeuringnederland.nl/aankoopkeuring-marktplaats/"
          data-ga-track-event={GA_TRACK_EVENTS_ACTIONS.OKNBannerClick}
        >
          <Trans tagName="span" i18nKey="inspectionService.buttonLabel" />
        </SecondaryButton>
      </div>
      <img src={inspectionServiceImageUrl} alt={t('inspectionService.imageAlt')} className={Classes.image} />
    </div>
  );
};

export default InspectionService;
